(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(h) {
    if (h.dataset.nvInit) return; h.dataset.nvInit = '1';
    var track = h.querySelector('.nv-slides'), dots = [].slice.call(h.querySelectorAll('.nv-dots button')), i = 0, timer;
    if (!track || !dots.length) return;
    function go(n) {
      i = (n + dots.length) % dots.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      dots.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    dots.forEach(function (b, k) { b.addEventListener('click', function () { go(k); start(); }); });
    function start() {
      clearInterval(timer);
      var s = +h.dataset.autoplay;
      if (s && !reduce && dots.length > 1) timer = setInterval(function () { go(i + 1); }, s * 1000);
    }
    h.addEventListener('mouseenter', function () { clearInterval(timer); });
    h.addEventListener('mouseleave', start);
    go(0); start();
  }

  function initCarousel(c) {
    if (c.dataset.nvInit) return; c.dataset.nvInit = '1';
    var t = c.querySelector('.nv-track'), p = c.querySelector('[data-prev]'), n = c.querySelector('[data-next]');
    if (!t || !t.firstElementChild) return;
    function step() { return t.firstElementChild.getBoundingClientRect().width + 22; }
    function update() { p.disabled = t.scrollLeft < 4; n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4; }
    p.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
    n.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
    t.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initMenu(b) {
    if (b.dataset.nvInit) return; b.dataset.nvInit = '1';
    var menu = document.getElementById(b.getAttribute('aria-controls'));
    if (!menu) return;
    function set(open) { menu.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    b.addEventListener('click', function () { set(menu.hidden); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { set(false); b.focus(); } });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-nv-hero]').forEach(initHero);
    root.querySelectorAll('[data-nv-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-nv-burger]').forEach(initMenu);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
